<template>
  <div class="number-value">
    <div v-if="label" class="number-value__label c-input-label">
      {{ label }}
      <div v-if="fullLabel" class="c-input-label-fullname">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: fullLabel,
            placement: 'bottom',
          }"
          size="iconic"
          icon="info"
        />
      </div>
    </div>

    <div class="number-value__container">
      <div class="number-value__type">
        <c-switcher
          :value="type"
          type="group"
          :label="label"
          :label-full-name="fullLabel"
          class="h-switcher"
          :items="items"
          @input="updateType"
        />
      </div>

      <div class="number-value-fields">
        <div class="number-value-fields__wrapper">
          <div v-if="isRange" class="number-value__range">
            <c-input
              v-model="from"
              class="range-input-width"
              type="price-number"
              placeholder="0"
              :split="true"
              :required-message="error"
              :max-length="11"
            />
            <span class="range-dash">–</span>
            <c-input
              v-model="to"
              class="range-input-width"
              type="price-number"
              placeholder="0"
              :split="true"
              :required-message="error"
              :max-length="11"
            />
          </div>
          <div v-else class="number-value__value">
            <c-input
              v-model="number"
              class="range-input-width"
              type="price-number"
              placeholder="0"
              :split="true"
              :required-message="error"
              :max-length="11"
            />
          </div>

          <span class="number-value__unit">{{ unit }}</span>
        </div>

        <error-feedback v-if="error" class="number-value__error" :text="error"></error-feedback>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_NUMBER, TYPE_RANGE, numberTypes } from "@/constants/numberValueTypes";
import NumberValue from "@/entities/structures/numberValue";

import CSwitcher from "@/components/controls2/Switcher";
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { CSwitcher, CInput, CButton, ErrorFeedback },
  props: ["value", "label", "fullLabel", "unit", "error"],
  data() {
    return {
      type: TYPE_NUMBER,
      number: "",
      from: "",
      to: "",

      items: numberTypes,
    };
  },
  computed: {
    isRange() {
      return this.type === TYPE_RANGE;
    },
  },
  watch: {
    value(v) {
      this.setValue(v);
    },
    from() {
      this.updateValue();
    },
    to() {
      this.updateValue();
    },
    number() {
      this.updateValue();
    },
  },
  created() {
    this.setValue(this.value);
  },
  methods: {
    updateType(v) {
      this.type = v;
      this.number = "";
      this.from = "";
      this.to = "";
      this.updateValue();
    },
    setValue(v) {
      this.updating = true;
      const { type, from, to, number } = v;
      this.type = type;
      this.$nextTick(() => {
        this.from = from;
        this.to = to;
        this.number = number;
      });
      this.updating = false;
    },
    updateValue() {
      const value = new NumberValue({
        type: this.type,
        from: this.from,
        to: this.to,
        number: this.number,
      });
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.number-value {
  &__container {
    display: flex;
  }

  &-fields {
    padding-top: 2px;
    margin-left: 30px;
    &__wrapper {
      display: flex;
    }
  }

  .range-input-width {
    width: 70px;
  }

  &__range {
    display: flex;

    .range-dash {
      margin: 0 15px;
    }
  }

  &__unit {
    margin-left: 15px;
    font-size: 13px;
  }

  @include onlyMobile {
    &__container {
      display: block;
    }
    &__type {
      width: 100%;
    }
    &-fields {
      width: 100%;
      margin-left: 0;
      margin-top: 24px;
    }

    &__value {
      padding-right: 15px;
      width: 33%;
      .range-input-width {
        width: 100%;
      }
    }
    &__range {
      padding-right: 15px;
      width: 66%;

      .range-dash {
        margin: 0;
        width: 15px;
        flex-shrink: 0;
      }

      .range-input-width {
        flex-basis: 50%;
        flex-grow: 1;
      }
    }
    &__unit {
      margin-left: 0;
    }
  }
}
</style>
